import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  requestInProcess,
  requestFinished,
  updateList,
  sendRequest,
  selectQueryParams
} from '../../../../../../common/reducers/list/reducer';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksService from '../../../../services/TasksService';
import { insertUpdateItems as insertUpdateObjectCollectionItems } from '../../../../../../common/reducers/objectCollection/reducer';

function* getNewTasks(reducerName) {
  yield put(requestInProcess(reducerName));
  const queryParams = yield select(selectQueryParams, reducerName);
  let status = null;
  try {
    const result = yield call(
      timeoutCall,
      TasksService.getTasksListHideTasks,
      queryParams
    );
    if (result.response) {
      status = result.response.status;
      if (result.response.status) {
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.tasksById,
            itemsIds: result.destructData.tasksIds,
            pagination: result.destructData.pagination
          })
        );
        yield put(
          insertUpdateObjectCollectionItems(
            'tasksModule.collections.tasksCollection',
            result.destructData.tasksById
          )
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function createSaga(reducerName) {
  return [takeEvery(sendRequest(reducerName).type, getNewTasks, reducerName)];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/lists/sagas/tasksListHideTasksSaga.js